import axios from '@/http/axios'

/* get opening inventories */
export function getOpeningInventories () {
  return axios({
    url: 'v1/admin/opening-inventories',
    method: 'get'
  })
}

/* lock opening inventories */
export function lockOpeningInventories () {
  return axios({
    url: 'v1/admin/opening-inventories/lock',
    method: 'post'
  })
}

/* unlock opening inventories */
export function unlockOpeningInventories () {
  return axios({
    url: 'v1/admin/opening-inventories/unlock',
    method: 'post'
  })
}

/* get, set and delete creditor users opening inventories */
export function getDebtorUsersOpeningInventories (page = 1) {
  let queries = []

  if (page > 1) {
    queries.push(`page=${page}`)
  }

  queries = queries.length > 0 ? `?${  queries.join('&')}` : ''

  return axios({
    url: `v1/admin/opening-inventories/debtor-users${queries}`,
    method: 'get'
  })
}

export function getDebtorUserOpeningInventories (id) {
  return axios({
    url: `v1/admin/opening-inventories/debtor-users/${id}`,
    method: 'get'
  })
}

export function setDebtorUsersOpeningInventories (payment) {
  return axios({
    url: 'v1/admin/opening-inventories/debtor-users',
    data: {users: payment},
    method: 'post'
  })
}

export function deleteDebtorUsersOpeningInventories (id) {
  return axios({
    url: `v1/admin/opening-inventories/debtor-users/${id}`,
    method: 'delete'
  })
}

/* get, set and delete creditor users opening inventories */
export function getCreditorUsersOpeningInventories (page = 1) {
  let queries = []

  if (page > 1) {
    queries.push(`page=${page}`)
  }

  queries = queries.length > 0 ? `?${  queries.join('&')}` : ''

  return axios({
    url: `v1/admin/opening-inventories/creditor-users${queries}`,
    method: 'get'
  })
}

export function getCreditorUserOpeningInventories (id) {
  return axios({
    url: `v1/admin/opening-inventories/creditor-users/${id}`,
    method: 'get'
  })
}

export function setCreditorUsersOpeningInventories (payment) {
  return axios({
    url: 'v1/admin/opening-inventories/creditor-users',
    data: {users: payment},
    method: 'post'
  })
}

export function deleteCreditorUsersOpeningInventories (id) {
  return axios({
    url: `v1/admin/opening-inventories/creditor-users/${id}`,
    method: 'delete'
  })
}

/* get, set and delete storerooms opening inventories */
export function getStoreroomsOpeningInventories (id, page = 1) {
  let queries = []

  if (page > 1) {
    queries.push(`page=${page}`)
  }

  queries = queries.length > 0 ? `?${  queries.join('&')}` : ''

  return axios({
    url: `v1/admin/opening-inventories/storerooms/${id}${queries}`,
    method: 'get'
  })
}

export function setStoreroomsOpeningInventories (id, payment) {
  return axios({
    url: `v1/admin/opening-inventories/storerooms/${id}`,
    data: {lines: payment},
    method: 'post'
  })
}

export function getStoreroomsProductOpeningInventories (id, stockId) {
  return axios({
    url: `v1/admin/opening-inventories/storerooms/${id}/stocks/${stockId}`,
    method: 'get'
  })
}

export function updateStoreroomsOpeningInventories (id, stockId, payment) {
  return axios.patch(`v1/admin/opening-inventories/storerooms/${id}/stocks/${stockId}`, payment)
}

export function deleteStoreroomsOpeningInventories (id, stockId) {
  return axios({
    url: `v1/admin/opening-inventories/storerooms/${id}/stocks/${stockId}`,
    method: 'delete'
  })
}

export function importStoreroomsOpeningInventories (id, payment) {
  return axios({
    url: `v1/admin/opening-inventories/storerooms/${id}/import`,
    data: payment,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'post'
  })
}

/* get, set and delete cash boxes opening inventories */
export function getCashBoxesOpeningInventories (page = 1) {
  let queries = []

  if (page > 1) {
    queries.push(`page=${page}`)
  }

  queries = queries.length > 0 ? `?${  queries.join('&')}` : ''

  return axios({
    url: `v1/admin/opening-inventories/cashes${queries}`,
    method: 'get'
  })
}

export function getCashBoxOpeningInventories (id) {
  return axios({
    url: `v1/admin/opening-inventories/cashes/${id}`,
    method: 'get'
  })
}

export function setCashBoxesOpeningInventories (payment) {
  return axios({
    url: 'v1/admin/opening-inventories/cashes',
    data: {cashes: payment},
    method: 'post'
  })
}

export function deleteCashBoxesOpeningInventories (id) {
  return axios({
    url: `v1/admin/opening-inventories/cashes/${id}`,
    method: 'delete'
  })
}

/* set banks opening inventories */
export function getBanksOpeningInventories (page = 1) {
  let queries = []

  if (page > 1) {
    queries.push(`page=${page}`)
  }

  queries = queries.length > 0 ? `?${  queries.join('&')}` : ''

  return axios({
    url: `v1/admin/opening-inventories/banks${queries}`,
    method: 'get'
  })
}

export function getBankOpeningInventories (id) {
  return axios({
    url: `v1/admin/opening-inventories/banks/${id}`,
    method: 'get'
  })
}

export function setBanksOpeningInventories (payment) {
  return axios({
    url: 'v1/admin/opening-inventories/banks',
    data: {banks: payment},
    method: 'post'
  })
}

export function deleteBanksOpeningInventories (id) {
  return axios({
    url: `v1/admin/opening-inventories/banks/${id}`,
    method: 'delete'
  })
}
